import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( /* webpackChunkName: "about" */ '../pages/HomePage/HomePage.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import( /* webpackChunkName: "about" */ '../pages/AboutPage/AboutPage.vue')
  },
  {
    path: '/informed',
    name: 'informed',
    component: () => import( /* webpackChunkName: "about" */ '../pages/InformedPage/informed.vue')
  },
  {
    path: '/detailInfoPage',
    name: 'detailInfoPage',
    component: () => import( /* webpackChunkName: "about" */ '../pages/InformedPage/detailInfoPage.vue')
  },
  {
    path: '/oldPlan',
    name: 'oldPlan',
    component: () => import( /* webpackChunkName: "about" */ '../pages/oldRenovationPlan/oldRenovationPlan.vue')
  },
  {
    path: '/researchDev',
    name: 'researchDev',
    component: () => import( /* webpackChunkName: "about" */ '../pages/researchDev/researchDev.vue')
  },
  {
    path: '/supplyChain',
    name: 'supplyChain',
    component: () => import( /* webpackChunkName: "about" */ '../pages/supplyChainPage/supplyChainPage.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import( /* webpackChunkName: "about" */ '../pages/productPage/productPage.vue'),
    meta: {
      showHeader: true,
      showFooter: true
    }
  },
  {
    path: '/classificationDetails',
    name: 'classificationDetails',
    component: () => import( /* webpackChunkName: "about" */ '../pages/productPage/classificationDetails.vue')
  },
  {
    path: '/previewFile',
    name: 'previewFile',
    component: () => import( /* webpackChunkName: "about" */ '../pages/previewPDFFile/index.vue'),
    meta: {
      showHeader: false,
      showFooter: false
    }
  },
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'link_active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有 savedPosition，直接返回，保持之前的滚动位置
      return savedPosition;
    } else {
      // 否则滚动到页面顶部
      return {
        x: 0,
        y: 0
      };
    }
  },
})

router.afterEach(() => {
  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
})

export default router
